import { render, staticRenderFns } from "./AllotAfter.vue?vue&type=template&id=7730d4d6"
import script from "./AllotAfter.vue?vue&type=script&lang=js"
export * from "./AllotAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports